import { localize } from "../../i18n";
import { STRING } from "../../i18n/base";

export const validateBodyShapeWaistStep = (profile, config) => {
  // BodyShapeWaist;

  if (validateBodyShapeWaist(profile.waistOffset)) {
    return false;
  }
  return true;
};

export const validateBodyShapeWaist = (value) => {
  if (value === "") {
    return localize(STRING.REQUIRED, {
      fieldName: localize(STRING.WAIST),
    });
  }
  return false;
};
